import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="py-8 border-t border-navy-800 bg-navy-900 text-center" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <p className="text-slate-500 text-sm" data-id="element-26">
          &copy; {currentYear} The 11PM Reset Protocol. All rights reserved.
        </p>
        <p className="text-slate-600 text-xs mt-2 max-w-2xl mx-auto" data-id="element-27">
          This site is not a part of the Facebook website or Facebook Inc.
          Additionally, This site is NOT endorsed by Facebook in any way.
          FACEBOOK is a trademark of FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}